//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const ObjectFunc = require('@/tbs/util/ObjectFunc')
const OrganizationSortTimeConvertor = require('@/tbs/model/vo/OrganizationSortTime')
const OrganizationConvertor = require('@/tbs/model/vo/Organization')
const OrganizationAuthenticationConvertor = require('@/tbs/model/vo/OrganizationAuthentication')
const DataConvertor = require('@/tbs/core/DataConvertor')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The OrganizationMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_OrganizationMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_OrganizationMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_OrganizationMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
         console.log('handleCreationComplete')
        if (this._bridge.isCreate()) {
            this.fetchCityRegion()
        }
        else if (this._bridge.isEdit()) {
            this.fetchCityRegion()
            this.creationComplete()
        }
        else if (this._bridge.isDetail()) {
            // this.creationComplete()
            this.target().onTabClick(Number(this._bridge.getRouteQuery('tab')))
        }
        else if (this._bridge.isCollection()) {
            this.creationComplete()
            if (this._bridge.getRouteQuery('organizationId')) {
                this.p_target().selectedOrganizationId = this._bridge.getRouteQuery('organizationId')
            }
        }
    },
    /**
     * @api
     * Handle the custom event condition triggered by 
     * the scene instance.
     * @event The event object contains 
     * {type:String, data:Object, target:VueComponent}
     */
    handleCustomEvent: function(event) {
        console.log('handleCustomEvent', event)
        if (event.type == 'save') {
            this.submitData(event.target, event.data, true)
        }
        else if (event.type == 'save-auth') {
            this.submitOrganizationAuthenticationInfo(event.target, event.data)
        }
        else if (event.type == 'submit') {
            this.submitData(event.target, event.data)
        }
        else if (event.type == 'delete') {
            this.deleteRecord(event.target, event.data)
        }
        else if (event.type == 'navigate') {
            this._bridge.goToScene(event.data.name, event.data.params, 
                ObjectFunc.mergeObject(event.data.query, {from: this._bridge.getRouteQuery('from')}))
        }
        else if (event.type == 'itemClick') {
            // save the click behavior on the server side
            this.changeOrganizationSortTime(event.data.organizationId)
            const from = this._bridge.getRouteQuery('from')
            if (from == 'OrgManageOrganization') {
                this._bridge.goToScene(this._bridge.getRouteQuery('from'), 
                    {id: event.data.organizationId})
            }
            else if (from == 'OrgCreateMatchName') {
                this._bridge.goToScene(this._bridge.getRouteQuery('from'), 
                    null, event.data)
            }
        }
        else if (event.type == 'tab') {
            console.log('tab', event.data.index)
            if (event.data.index == 0) {
                // load the organization basic info
                this.loadOrganizationBasicInfo(this._bridge.getRouteParam('id'))
            }
            else if (event.data.index == 1) {
                // load the organization authentication info
                this.loadOrganizationAuthenticationInfo(this._bridge.getRouteParam('id'))
            }
        }
    },
    handleRouteBack: function() {
        if (this._bridge.getRouteQuery('action') == 'exit') {
            this.exitPage()
        }
        else {
            this._bridge.back()
        }
    },
    handleRemoveService: function() {
        this._bridge.back(-2)
    },
    handleCreateService: function(e)  {
        if (e.data.result == true) {
            console.log('handleCreateMethod', e.data)
            // ModelLocator.setStatus('organizationName', e.data.options.organizationName)
            // ModelLocator.setStatus('organizationLogoUrl', e.data.options.organizationLogoUrl)
            const from = this._bridge.getRouteQuery('from')
            const organizationId = e.data.payload.data.id
            if (from == 'OrgCreateMatchName') {
                const query = {
                    organizationId: organizationId,
                    organizationName: e.data.options.data.name,
                    organizationLogoUrl: e.data.options.data.logo,
                    organizationAreaId: e.data.options.data.areaId,
                    organizationArea: e.data.options.data.area,
                }
                // save the click behavior on the server side
                this.changeOrganizationSortTime(organizationId)
                this._bridge.goToScene(from, null, query)
            }
            else if (from == 'OrgManageOrganization') {
                // save the click behavior on the server side
                this.changeOrganizationSortTime(organizationId)
                this._bridge.goToScene(from, {id: organizationId})
            }
        }
    },
    submitOrganizationAuthenticationInfo: function(target, data) {
        console.log('submitOrganizationAuthenticationInfo', target, data)
        const self = this
        const convertor = new OrganizationAuthenticationConvertor
        const type = data.status == '1' ? 'create' : 'update'
        const postBody = DataConvertor.transform(convertor, data, type)
        const source = convertor.view[type]
        const service  = type + 'OrganizationAuthentication'
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log(type + '.data', service, e.data)
            self._bridge.goToScene('OrgManageOrganization', self._bridge.getRouteParam())
        })
        if (type == 'create') {
            self._bridge.callResourceInstance(service, {
                baseUrl: source.baseUrl,
                apiPrefix: source.apiPrefix,
                apiSuffix: source.apiSuffix,
                serviceName: source.service,
                method: 'POST',
                data: postBody
            })
        }
        else if (type == 'update') {
            self._bridge.callResourceInstance(service, {
                baseUrl: source.baseUrl,
                apiPrefix: source.apiPrefix,
                apiSuffix: source.apiSuffix,
                serviceName: source.service,
                method: 'POST',
                data: postBody
            })
        }
    },
    changeOrganizationSortTime: function(organizationId) {
        const self = this
        const convertor = new OrganizationSortTimeConvertor()
        const source = convertor.view.update
        const service = 'updateOrganizationSortTime'
        const postBody = DataConvertor.transform(convertor, {organizationId: organizationId}, 'update')
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('update.data', service, e.data)
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'POST',
            data: postBody
        })
    },
    loadOrganizationBasicInfo: function(organizationId) {
        console.log('loadOrganizationBasicInfo', organizationId)
        const self = this
        const convertor = new OrganizationConvertor
        const type = 'get'
        const source = convertor.view[type]
        const service  = type + 'Organization'
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('get.data', service, e.data)
            const viewData = DataConvertor.transform(convertor, e.data.payload, type)
            const wrapper = DataConvertor.wrapper(convertor)
            self.target()[wrapper] = viewData
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'GET',
            parameters: { id: organizationId }
        })
    },
    loadOrganizationAuthenticationInfo: function(organizationId) {
        console.log('loadOrganizationAuthenticationInfo', organizationId)
        const self = this
        const convertor = new OrganizationAuthenticationConvertor
        const type = 'get'
        const source = convertor.view[type]
        const service  = type + 'OrganizationAuthentication'
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('get.data', service, e.data)
            const viewData = DataConvertor.transform(convertor, e.data.payload, type)
            const wrapper = DataConvertor.wrapper(convertor)
            console.log('wrapper.viewData', wrapper, viewData)
            self.target()[wrapper] = viewData
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'GET',
            parameters: { id: organizationId }
        })
    },
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_OrganizationMediator, BaseMediator);

module.exports = tbs_controller_OrganizationMediator